import React from 'react';
import ImageTile from './tiles/ImageTile';
import TextTile from './tiles/TextTile';
import styles from './TilesSection.module.css';

/** @param {FF.ContentfulTilesSectionProps} props */
export default function TilesSection({ className = '', tilesList }) {
  let wrapperClass;
  switch (tilesList.length) {
    case 8:
      wrapperClass = styles.wrapper8Tiles;
      break;
    case 6:
      wrapperClass = styles.wrapper6Tiles;
      break;
    case 4:
      wrapperClass = styles.wrapper4Tiles;
      break;
    default:
      throw new Error('Tile Section expects length of 4, 6, or 8 tiles');
  }
  return (
    <div className={`${wrapperClass} ${className}`}>
      {tilesList.map(tile => {
        if (tile.__typename === 'ContentfulImageTile') {
          return <ImageTile className={styles.tile} {...tile} />;
        }
        if (tile.__typename === 'ContentfulTextTile') {
          return <TextTile className={styles.tile} {...tile} />;
        }
        return null;
      })}
    </div>
  );
}
